import { createApi } from '@reduxjs/toolkit/query/react';
import { createCustomFetchBaseQuery } from '../baseQuery';


export const NotificationRules = createApi({
    reducerPath: "notification-rules",
    tagTypes: ['NotificationRules'],
    baseQuery: createCustomFetchBaseQuery(),
    endpoints: (builder) => ({
        getNotificationRules: builder.query({
            query: ({ pageno}) => {
                let url = `admin/notification-rules`;

                if(pageno){
                    url += `?pageno=${pageno}`;
                }

                return {
                    url,
                    method: "GET"
                }
            },
            providesTags: ["NotificationRules"],
        }),
        updateNotificationRule: builder.mutation({
            query: ({ id, data }) => ({
                url: `admin/notification-rule/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["NotificationRules"],
        }),
        markNotificationRead: builder.mutation({
            query: ({data}) => ({
                url: `notifications`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["NotificationRules"],
        })
    })
})

export const { useGetNotificationRulesQuery , useUpdateNotificationRuleMutation, useMarkNotificationReadMutation} = NotificationRules